import { useState, useEffect } from "react";
import PropTypes from "prop-types";
import { Link } from "react-router-dom";
import { Toast } from "./../UI/toast/Toast";
import { Button, Form, FormGroup, Input, Label } from "reactstrap";
import withRedirect from "../../helpers/hoc/withRedirect";
import { useDispatch, useSelector } from "react-redux";
import { Login } from "../../actions/authActions";
import { getErrorMessage } from "../../helpers/errors/handleErrorMessage";
import {
  isTooManyRequests,
  notifyTooManyRequests,
} from "../../helpers/errors/tooManyRequests";
import Loader from "../common/Loader";
import PasswordInput from "../common/PasswordInput";

const LoginForm = ({ setRedirectUrl, setRedirect }) => {
  const { isLogged, isLoading } = useSelector((state) => state.auth);
  const dispatch = useDispatch();
  const [username, setUsername] = useState("");
  const [password, setPassword] = useState("");
  const [isDisabled, setIsDisabled] = useState(true);
  // HO-TASK-297: segundos que faltan para poder reintentar tras un 429.
  const [retryIn, setRetryIn] = useState(0);

  const { errors } = useSelector((state) => state.auth);

  const handleSubmit = (e) => {
    e.preventDefault();
    if (retryIn > 0) return;
    dispatch(Login({ username, password }));
  };

  useEffect(() => {
    setIsDisabled(!username || !password);
  }, [username, password]);

  useEffect(() => {
    setRedirectUrl(`/dashboard/app`);
  }, [setRedirectUrl]);

  useEffect(() => {
    if (isLogged) {
      setRedirect(true);
    }
  }, [isLogged, setRedirect]);

  useEffect(() => {
    if (errors === null) return;

    if (isTooManyRequests(errors)) {
      notifyTooManyRequests(errors);
      if (errors.retry_after > 0) {
        setRetryIn(Math.ceil(errors.retry_after));
      }
      return;
    }

    Toast.fire({
      type: "error",
      title: getErrorMessage(errors?.code),
    });
  }, [errors]);

  useEffect(() => {
    if (retryIn <= 0) return;
    const timer = setTimeout(() => setRetryIn((seconds) => seconds - 1), 1000);
    return () => clearTimeout(timer);
  }, [retryIn]);

  return (
    <>
      <Form onSubmit={handleSubmit}>
        <FormGroup>
          <Label for="login-username">Correo o usuario</Label>
          {/* Se entra con el correo o con un usuario (VIL-01, por ejemplo,
              el de los vigilantes): con type="email" el navegador bloqueaba
              el envío de cualquier usuario sin "@". */}
          <Input
            id="login-username"
            type="text"
            autoComplete="username"
            autoCapitalize="none"
            autoCorrect="off"
            spellCheck={false}
            value={username}
            onChange={({ target }) => setUsername(target.value)}
          />
        </FormGroup>
        <FormGroup className="mb-2">
          <Label for="login-password">Contraseña</Label>
          <PasswordInput
            id="login-password"
            autoComplete="current-password"
            value={password}
            onChange={({ target }) => setPassword(target.value)}
          />
        </FormGroup>
        <div className="text-right mb-3">
          <Link className="fs--1" to={`/authentication/forget-password`}>
            ¿Olvidaste tu contraseña?
          </Link>
        </div>
        {!isLoading ? (
          <Button color="primary" block disabled={isDisabled || retryIn > 0}>
            {retryIn > 0 ? `Espera ${retryIn} s` : "Iniciar sesión"}
          </Button>
        ) : (
          <Loader />
        )}
        <div className="hl-auth__divider">o</div>
        <Button tag={Link} to={`/authentication/validate-mail`} color="falcon-default" block>
          Verificar mi cuenta
        </Button>
      </Form>
    </>
  );
};

LoginForm.propTypes = {
  setRedirect: PropTypes.func.isRequired,
};


export default withRedirect(LoginForm);
